export default __webpack_public_path__ + "static/media/posingLogo.292d75ad.jpeg";